
import React from 'react';


import {
} from '../../api/methodPayment.api';

import {connect} from 'react-redux';
import html2pdf from 'html2pdf.js';
import LoftyDropdownComponent from '../../components/loftydropdowncomponent';
import LoftyCountDown from '../../components/loftycountdown';
import LoftyCartCarousel from '../../components/loftycartcarousel';
import LoftyThreeCarousel from '../../components/loftythreecarousel';
import LoftyCarouselPlugin from '../../components/LoftyCarouselPlugin';
import LoftyLeaftMap from '../../components/loftyLeaftMaps';
import LoftyAnimatedParticleBackground from '../../components/loftyAnimatedParticleBackground';
import LoftyGoogleLoginComponent from '../../components/loftyGoogleLoginComponent';

import { addLoftyToken, deleteLoftytoken } from '../../actions/auth.actions';


import './sobrenosotrosnmlqp.scss';


// Hamburger
function loftyInitHam() {
  try {
  // eslint-disable-next-line no-restricted-globals
    window.addEventListener('click', (event) => {
      let originPointLeft = '';
      const comp = event.target.className;
      if (comp.includes('menu__btn') || comp.includes('span_middle') || comp.includes('span_before') || comp.includes('span_after')) {
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        spanData.forEach((item) => {
          originPointLeft = item.style.left;
        });
        res.forEach((item) => {
          item.style.left = '0px';
        });
        spanData.forEach((item) => {
          item.style.left = '-300px';
        });
        closeBtn.forEach((item) => {
          item.style.left = '10px';
        });
      } else {
        if (comp === 'menu__box') {
          return;
        }
        if (comp === 'linkshref') {
          return;
        }
        if (comp === 'menu__item') {
          return;
        }
        const res = Array.from(document.getElementsByClassName('menu__box'));
        const spanData = Array.from(document.getElementsByClassName('menu__btn'));
        const closeBtn = Array.from(document.getElementsByClassName('menu__close__btn'));
        res.forEach((item) => {
          item.style.left = '-300px';
        });
        spanData.forEach((item) => {
          item.style.left = originPointLeft;
        });
        closeBtn.forEach((item) => {
          item.style.left = '-100%';
        });
      }
    });
  } catch (error) {
    // console.log(error);
  }
}    
    




const Psobrenosotrosnmlqp = ({
  match,
  history,
  loftytoken,
  loftyuser,
  addLoftyUserApp,
  deleteLoftytokenApp,
  addLoftyTokenApp,
  
}) => {






  
  setTimeout(() => { loftyInitHam(); }, 2000);

  
  

  
  return (
    <div id="id6931b5148e5aed52dc8a9c57" >

      <div id="iw4j" className="">
      
      <div id="ips2" className="">
      
        <a
          target=""
          className=""
          id="iumht8"
          href="/"
        >
          
      <img
        className=""
        id="ismeq"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
        </a>
        
      <div id="itmdc" className="">
      
        <a
          target=""
          className="link-menu "
          id="iijdu7"
          href="/sobrenosotros"
        >
          
    <div id="inoik6" className="">
    <>Quienes Somos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="ijau3l"
          href="/proyectos"
        >
          
    <div id="i1h6oa" className="">
    <>Proyectos</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iwrqtz"
          href="/campanas"
        >
          
    <div id="ipmtmf" className="">
    <>Campañas</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="imshx9"
          href="/impacto"
        >
          
    <div id="itxxvc" className="">
    <>Impacto Social</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iefn8b"
          href="/impacto"
        >
          
    <div id="itdhxg" className="">
    <>Convenios</>
    </div>
    
        </a>
        
        <a
          target=""
          className="link-menu "
          id="iq6orv"
          href="/transparencia"
        >
          
    <div id="i1hchl" className="">
    <>Transparencia</>
    </div>
    
        </a>
        
      </div>
      
        <a
          target=""
          className="boton-primario "
          id="iiit99"
          href="/contacto"
        >
          
    <div id="i1fieg" className="">
    <>Contáctanos</>
    </div>
    
        </a>
        
      <div id="icq3pj" className="">
      
      <div id="" className="contentwrapperanimated ">
      
      <div id="" className="container_animated ">
      
      <label id="" className="menu__btn ">
      
      <span className="span_before " id="">
        
      </span>
      
      <span className="span_middle " id="">
        
      </span>
      
      <span className="span_after " id="">
        
      </span>
      
      </label>
      
      <label id="" className="menu__close__btn ">
      
      <span className="span__close__left " id="">
        
      </span>
      
      <span className="span__close__right " id="">
        
      </span>
      
      </label>
      
      <ul id="" className="menu__box ">
        
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/"
        type=""
      >
        <>Inicio</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/sobrenosotros"
        type=""
      >
        <>Sobre nosotros</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/proyectos"
        type=""
      >
        <>Proyectos</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/campanas"
        type=""
      >
        <>Campañas</>
      </a>
      
      </li>
      
      <li className="linkshref " id="">
        
      <a
        target=""
        className="menu__item "
        id=""
        href="/impacto"
        type=""
      >
        <>Impacto social</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/convenios"
        type=""
      >
        <>Convenios</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/transparencia"
        type=""
      >
        <>Transparencia</>
      </a>
      
      <a
        target=""
        className="menu__item "
        id=""
        href="/contacto"
        type=""
      >
        <>Contacto</>
      </a>
      
      </li>
      
      </ul>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="ihk8" className="">
      
      <div id="it6xg" className="">
      
      <div className="" id="ip3sl">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ingwtg">
        <>Nuestra identidad</>
      </span>
      
      </div>
      
      <div id="igfc86" className="">
      
      <div id="iyzcs2" className="">
      
      <img
        className=""
        id="i8cn9i"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirnkiru.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i2up4h" className="">
      
      <div className="" id="iyrhj6">
        <>Está conformada por familias campesinas y víctimas del conflicto que habitan la Finca La Comuna, en la vereda La Selva, corregimiento La Estrella Palmilla, municipio de Pereira (Risaralda).</>
      <br className="" id="" />
      <>Somos una organización social y agropecuaria que impulsa la productividad, la convivencia y la organización comunitaria a través de proyectos agrícolas y alianzas con instituciones nacionales e internacionales.</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i3m0i" className="">
      
      <div id="ikse2e" className="">
      
      <div id="iuzglb" className="">
      
      <div className="" id="if4w2o">
        <>Misión</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="i4gluv">
        <>Fortalecer la productividad agropecuaria y la asociatividad de las familias campesinas y víctimas del conflicto que integran Fundación Petrus, promoviendo la seguridad alimentaria, la sostenibilidad ambiental y el encadenamiento productivo regional.</>
      </div>
      
      </div>
      
      <div id="ill3zk" className="">
      
      <img
        className=""
        id="idbf4d"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirnp5ac.png"
        alt="undefined"
      />
      
      </div>
      
      </div>
      
      </div>
      
      <div id="izdkrq" className="">
      
      <div id="iou2cz" className="">
      
      <div id="iqpteu" className="">
      
      <img
        className=""
        id="iib6bz"
        src="https://assetsprojects.s3.amazonaws.com/404pziimirnrva1.png"
        alt="undefined"
      />
      
      </div>
      
      <div id="i6wf3u" className="">
      
      <div className="" id="ii5v25">
        <>Visión</>
      <br className="" id="" />
      
      </div>
      
      <div className="" id="iqfsim">
        <>Proyectarnos como una organización social y agropecuaria referente en el Eje Cafetero, reconocida por su modelo de productividad rural con enfoque social, sus buenas prácticas agropecuarias y su articulación con cadenas productivas locales, regionales y nacionales</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iencce" className="">
      
      <div className="" id="i7p7tx">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="ie7jd4">
        <>Equipo directivo</>
      </span>
      
      </div>
      
      </div>
      
      <div id="iuo301" className="">
      
      <div id="ixrbfk" className="">
      
      <div id="ivy1ig" className="tarjeta-persona ">
      
      <div id="i0atys" className="">
      
      <img
        className=""
        id="i3okln"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja0yw73.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="iggr93" className="">
      
      <div className="titulo-tarjeta-persona " id="iu4a2q">
        <>Leyli Guardado</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="i8097h">
        <>Presidenta</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iy4zhy" className="tarjeta-persona ">
      
      <div id="ii3vst" className="">
      
      <img
        className=""
        id="ivyx5l"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja10jsc.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="ik1gkg" className="">
      
      <div className="titulo-tarjeta-persona " id="i2hh9l">
        <>Nohemy Candamil</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="ioy086">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="in7akj">
        <>Directora de ONG y Asesora de Proyectos</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="inw11u" className="tarjeta-persona ">
      
      <div id="i1xkib" className="">
      
      <img
        className=""
        id="ialy8v"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja119n8.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="ixoe62" className="">
      
      <div className="titulo-tarjeta-persona " id="ikfysk">
        <>Jairo Urrutia</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="i6mh9j">
        
      <span className="" id="">
        
      </span>
      
      <span className="" id="">
        
      </span>
      
      <span className="" id="idh9sr">
        <>Director de Asuntos Legales</>
      </span>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="i2mnpm" className="tarjeta-persona ">
      
      <div id="if153d" className="">
      
      <img
        className=""
        id="ixkoye"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja12kip.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="iutdca" className="">
      
      <div className="titulo-tarjeta-persona " id="i63vzj">
        <>Marco Covera</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="ivn5x7">
        <>Asesor Financiero</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iw48aq" className="tarjeta-persona ">
      
      <div id="indxx3" className="">
      
      <img
        className=""
        id="isa5c9"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja137k7.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="ihawqh" className="">
      
      <div className="titulo-tarjeta-persona " id="iavudl">
        <>Andry Mota</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="i9y4jm">
        <>Directora Fundación Petrus</>
      </div>
      
      </div>
      
      </div>
      
      <div id="iom4lf" className="tarjeta-persona ">
      
      <div id="i612te" className="">
      
      <img
        className=""
        id="i1cya4"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja13loh.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="i2i1yg" className="">
      
      <div className="titulo-tarjeta-persona " id="iohhes">
        <>Carlos Handal</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="i19q0i">
        <>Director de Proyectos</>
      </div>
      
      </div>
      
      </div>
      
      <div id="ips8rl" className="tarjeta-persona ">
      
      <div id="iyajxa" className="">
      
      <img
        className=""
        id="iwvx89"
        src="https://assetsprojects.s3.amazonaws.com/404pziimja15274.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="ioq3yv" className="">
      
      <div className="titulo-tarjeta-persona " id="imtbtj">
        <>Jose Sierra</>
      </div>
      
      <div className="cargo-tarjeta-persona " id="iax85q">
        <>Asesor de la fundación</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="icohi" className="">
      
      <div id="iyghfd" className="">
      
      <div id="i52pnr" className="">
      
      <div className="" id="iyo7r6">
        
      <span className="" id="icvuhe">
        <>Fundación Petrus</>
      </span>
      
      </div>
      
      <img
        className=""
        id="ici88m"
        src="https://assetsprojects.s3.amazonaws.com/404pziimiyli40g.jpg"
        alt="undefined"
      />
      
      </div>
      
      <div id="invc11" className="">
      
      <div id="id3akf" className="">
      
      <div className="" id="i160fk">
        <>Páginas</>
      </div>
      
      <div className="" id="igdgp1">
        <>Quienes Somos</>
      </div>
      
      <div className="" id="io8u0g">
        <>Proyectos</>
      </div>
      
      <div className="" id="ifh4ms">
        <>Impacto Social</>
      </div>
      
      </div>
      
      <div id="ipuzkj" className="">
      
      <div className="" id="ifh7p5">
        <>Más información</>
      </div>
      
      <div className="" id="il1rnw">
        <>Contacto</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
      <div id="iou1pv" className="">
      
      <div className="" id="izq2dp">
        <>Todos lo derechos reservados</>
      </div>
      
      </div>
      
      </div>
      
      </div>
      
</div>
  );
}

const mapStateToProps = (state) => state.auth;

const mapDispatchToProps = (dispatch) => ({
 addLoftyTokenApp: (data) => dispatch(addLoftyToken(data)),
 deleteLoftytokenApp: () => dispatch(deleteLoftytoken()),
});


export default connect(mapStateToProps, mapDispatchToProps)(Psobrenosotrosnmlqp);
  